module.exports = __webpack_public_path__ + "img/master-card-dark.e52bb497.svg";